export function findMaxPillCountBasedOnValueLabelLength(
  maxChars: number | undefined,
  values: { label: string; value: string }[]
) {
  const result =
    maxChars !== undefined
      ? values.reduce(
          (acc, v) => {
            const chars = acc.chars + (v.label?.length ?? 0) + 4 // + 4 for spaces between pills
            const pillCount = acc.pills + 1

            return {
              chars,
              pills: pillCount,
              maxPills:
                acc.maxPills === undefined && chars > maxChars
                  ? acc.pills
                  : acc.maxPills,
            }
          },
          { chars: 0, pills: 0, maxPills: undefined as undefined | number }
        )
      : null
  return result?.maxPills || null
}
